import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { organizedNeeds, systemFlow } from '../data/content';
import { Mark, SectionTitle } from './ui/Section';
export function ProblemSolution() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-165" data-mp="3mrb7671y0tw9">
      <div className="mx-auto max-w-5xl" data-id="element-166" data-mp="3hr6qoh11bz61">
        <SectionTitle data-id="element-167" data-mp="3hs8dfireya3l">
          What if your rehabilitation exercise system <Mark data-id="element-168" data-mp="ibtlfxtouz4e">was already organized?</Mark>
        </SectionTitle>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-steel md:text-base" data-id="element-169" data-mp="ie5zw108mrcp">
          You may already know plenty of exercises. The challenge is knowing which one fits the current level, how much
          to perform and what should come next.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-center text-sm leading-relaxed text-steel md:text-base" data-id="element-170" data-mp="4ker4uubzbi1">
          With the Complete Injury Rehabilitation Bundle, you get a structured exercise library covering the major
          joints and movement regions of the body.
        </p>
        <p className="mt-5 text-center font-display text-sm font-black uppercase tracking-[.2em] text-brand" data-id="element-171" data-mp="6tu0xxk37udj">
          Choose. Apply. Progress.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-172" data-mp="3u5uv0tvbn90w">
          <div className="flex flex-col rounded-2xl border border-navy/10 bg-canvas p-6" data-id="element-173" data-mp="3u5cuhl1mm8n6">
            <h3 className="font-display text-base font-black uppercase leading-tight text-navy md:text-lg" data-id="element-174" data-mp="2095ac5yvchi">
              Turn scattered exercises into a clear progression
            </h3>
            <div className="mt-3 flex-1 space-y-2 text-sm leading-relaxed text-steel" data-id="element-175" data-mp="3p7bdr6roalev">
              <p data-id="element-176" data-mp="3b7sbuvpgg6b0">Exercises saved from videos, posts and different resources can quickly become difficult to organize.</p>
              <p data-id="element-177" data-mp="3f8m2vxy72184">
                This system brings together mobility, activation, strengthening, stability and progressive exercise
                options in one place.
              </p>
              <p data-id="element-178" data-mp="1dgfoi05vupq8">Each exercise includes practical guidance such as sets, reps, rest periods and progression options.</p>
            </div>
            <p className="mt-5 font-display text-xs font-black uppercase tracking-wider text-brand" data-id="element-179" data-mp="2mbjnoaalmbez">
              More structure. More clarity. Better organization.
            </p>
          </div>

          <div className="flex flex-col rounded-2xl bg-navy p-6" data-id="element-180" data-mp="2df2gfi5cuxoi">
            <h3 className="font-display text-base font-black uppercase leading-tight text-white md:text-lg" data-id="element-181" data-mp="28fpm6cc5mobw">
              One system. Multiple levels. <span className="text-brand-light" data-id="element-182" data-mp="312seunu5g4u8">Practical exercises ready to use.</span>
            </h3>
            <ul className="mt-4 flex-1 space-y-2.5" data-id="element-183" data-mp="2wbty5n5914qg">
              {organizedNeeds.map(item => <li key={item} className="flex items-start gap-2 text-sm text-white/85" data-id="element-184" data-mp="2rd8vlh2iy8yu">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-light" aria-hidden="true" data-id="element-185" data-mp="3osefzgu30u4v" />
                  {item}
                </li>)}
            </ul>
            <ol className="mt-5 flex flex-wrap items-center gap-1.5" data-id="element-186" data-mp="3jzlbmu2izntb">
              {systemFlow.map((step, index) => <li key={step} className="flex items-center gap-1.5" data-id="element-187" data-mp="69ny6sjma0y" data-mpi={index}>
                  {index > 0 && <ArrowRightIcon className="h-3.5 w-3.5 text-brand-light" aria-hidden="true" data-id="element-188" data-mp="8clrczxt7g8" />}
                  <span className="whitespace-nowrap rounded-md bg-white px-2 py-1 text-[10px] font-black uppercase tracking-wide text-navy" data-id="element-189" data-mp="57yzronlarq3">
                    {step}
                  </span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}